
















































































































































import {Component, Ref, Vue} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import AdvertisementApi, {AdPagingForm} from "@/module/ad/AdvertisementApi";
import PaginationTable from "@/component/Table/pagination-table.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";
import IdColumn from "@/component/Table/id-column.vue";
import DeleteDialog from "@/component/Crud/delete-dialog.vue";
import Advertisement from "@/module/ad/Advertisement";
import AdCreateDialog from "@/view/ad-manage/ad/create-dialog.vue";
import AdEditDialog from "@/view/ad-manage/ad/edit-dialog.vue";

@Component({
  components: {
    AdCreateDialog,
    AdEditDialog,
    DeleteDialog,
    IdColumn,
    RefreshButton,
    PaginationTable,
  }
})
export default class AdView extends Vue {

  private api=Container.get(AdvertisementApi)

  @Ref()
  private ptable!: PaginationTable

  private pqForm = new AdPagingForm()

  private getPaging() {
    return this.api.paging(this.pqForm)
  }

  private refresh() {
    this.ptable?.refresh()
  }

  private search(reset = false) {
    if (reset)
      this.pqForm.currentPage = 1
    this.refresh()
  }

  @Ref()
  private createDialog!: AdCreateDialog

  private handleCreateClick() {
    this.createDialog.open()
  }

  @Ref()
  private editDialog!: AdEditDialog

  private handleEditClick(ad: Advertisement) {
    this.editDialog.openAd(ad)
  }

  @Ref()
  private deleteDialog!: DeleteDialog

  private ad = new Advertisement()

  private async handleDeleteClick(ad: Advertisement) {
    this.ad = ad
    this.deleteDialog.open()
  }

  private async confirmDelete() {
    return this.api.delete(this.ad.id)
  }

  private openMinIO() {
    window.open('https://minio.qianj.top/minio/iot-prod/ad/', 'blank')
  }
}
